import React from 'react';
import { useNavigate } from 'react-router-dom';

function Logo() {
  const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  const logoSrc = isChrome ? "/yin-yang.png" : "/yin-yang.svg";
  // For navigating programmatically
  const navigate = useNavigate();

  return (
    <div className="logo" style="cursor: pointer; justify-items: center; align-items: center" onClick={() => navigate('/')}>
        <img src={`${logoSrc}`} alt="BetterBaduk" />
        <h1 style="justify-items:center; align-items: center">
        BetterBaduk
        </h1>
    </div>
  );
}

export default Logo;